import { frontendURL } from 'dashboard/helper/URLHelper.js';
import BulkMessages from './BulkMessages.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const bulkMessagesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/bulk-messages'),
      name: 'bulk_messages_index',
      meta,
      component: BulkMessages,
    },
  ],
};

export default bulkMessagesRoutes;
